import classnames from 'classnames/bind'
import React from 'react'

import Accordion from '~/components/Accordion'
import AccordionPanel from '~/components/Accordion/AccordionPanel'
import RichText from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import { ReactComponent as Arrow } from './arrow-down.svg'
import css from './styles.module.scss'
import { AccordionTextProps } from './types'

const cx = classnames.bind(css)

function AccordionText({ className, title, items }: AccordionTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-section' })
  const itemTitleStyle = useStyle({
    textPreset: 'title-heading-5',
    color: 'ebony',
  })
  const textStyle = useStyle({ textPreset: 'text-body' })

  return (
    <div className={cx(css.AccordionText, gridStyle, className)}>
      <div className={css.content}>
        {title && (
          <RichText className={cx(css.title, titleStyle)} render={title} />
        )}
        {items?.length > 0 && (
          <Accordion className={css.accordion}>
            {items.map?.((item, index) => (
              <AccordionPanel
                className={css.accordionItem}
                index={index}
                key={index}
                head={(isActive: boolean) => {
                  return (
                    <div
                      className={cx(css.sectionTitle, itemTitleStyle, {
                        isActive,
                      })}>
                      <div className={css.headWrapper}>
                        {item?.title && <RichText render={item.title} />}
                      </div>

                      <Arrow className={cx(css.icon, { isActive })} />
                    </div>
                  )
                }}
                body={
                  <div className={css.sectionBody}>
                    {item?.text && (
                      <RichText
                        className={cx(css.text, textStyle)}
                        render={item.text}
                      />
                    )}
                  </div>
                }
              />
            ))}
          </Accordion>
        )}
      </div>
    </div>
  )
}

AccordionText.defaultProps = {}

export default AccordionText
